export const DEFAULT_PAGE_DOMAIN = "https://pagepro.co";
